import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './SwipeUp.scss';

const SwipeUp = (props) => (
    <Icon iconName="SwipeUp" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 26">
            <path
                // eslint-disable-next-line
                d="M.7 4.619c-.1 0-.2 0-.3-.1-.2-.2-.2-.5 0-.8l2.7-3.3c.1-.1.2-.2.4-.2.1 0 .3.1.4.2l2.9 3.2c.2.2.2.5 0 .7-.2.2-.5.2-.7 0l-2.5-2.8-2.4 2.9c-.2.1-.3.2-.5.2z"
            />
            <path
                // eslint-disable-next-line
                d="M3.6 17.819c-.3 0-.5-.2-.5-.5v-15.9c0-.3.2-.5.5-.5s.5.2.5.5v15.9c0 .3-.2.5-.5.5z"
            />
            <g>
                <path
                    // eslint-disable-next-line
                    d="M19.1 25.719c-.2 0-.4 0-.6-.1-.5-.2-.9-.5-1.1-1-.2-.4-.3-1-.1-1.5.2-.5.5-.9 1-1.1l1-.6H8.7c-1 0-1.9-.9-1.9-1.9 0-1 .9-1.9 1.9-1.9h3.9c-.1-.3-.2-.6-.2-.9 0-.7.4-1.4 1.1-1.7-.3-.2-.5-.6-.5-1 0-1 .9-1.9 1.9-1.9h2.8c.3 0 .5.2.5.5s-.2.5-.5.5h-2.8c-.5 0-.9.4-.9.9s.4.9.9.9H17c.3 0 .5.2.5.5s-.2.5-.5.5h-2.8c-.5 0-.9.4-.9.9s.4.9.9.9h2.1c.3 0 .5.2.5.5s-.2.5-.5.5H8.6c-.5 0-.9.4-.9.9s.4.9.9.9h12.5c.1 0 .1 0 .2.1.1 0 .1.1.2.1 0 0 .1.1.1.2v.2c0 .1 0 .1-.1.2s-.1.1-.1.2l-2.6 1.5c-.3.1-.4.3-.5.5-.1.2-.1.5.1.7.1.2.3.4.5.5.2.1.5.1.7-.1l6.8-4.1c.2-.1.5-.1.7.2.1.2.1.5-.2.7l-6.9 4.1c-.3.1-.6.2-.9.2z"
                />
                <path
                    // eslint-disable-next-line
                    d="M26.6 21.419c-.2 0-.3-.1-.4-.2-.2-.2-.1-.6.1-.7.9-.6 1.4-1.5 1.4-2.6v-4.6c0-1.7-1.3-3-3-3h-8.4c-.5 0-.9.4-.9.9s.4.9.9.9c.3 0 .5.2.5.5s-.2.5-.5.5c-1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9h8.5c2.2 0 4 1.8 4 4v4.6c0 1.4-.7 2.7-1.9 3.4-.1.1-.2.1-.3.1z"
                />
            </g>
        </svg>
    </Icon>
);

export default SwipeUp;
